import { generateClientId } from '../../ids.js';

type WorkspaceSessionState = Readonly<{
  patientUserId: string;
  workspaceSessionId: string;
}>;

let activeWorkspaceSession: WorkspaceSessionState | null = null;

function normalizeUserId(userId: string): string {
  return userId.trim();
}

export function startWorkspaceSession(patientUserId: string): string {
  const normalized = normalizeUserId(patientUserId);
  if (normalized === '') {
    return generateClientId();
  }

  if (activeWorkspaceSession?.patientUserId === normalized) {
    return activeWorkspaceSession.workspaceSessionId;
  }

  const workspaceSessionId = generateClientId();
  activeWorkspaceSession = { patientUserId: normalized, workspaceSessionId };
  return workspaceSessionId;
}

export function getWorkspaceSessionId(patientUserId: string): string | undefined {
  const normalized = normalizeUserId(patientUserId);
  if (normalized === '') {
    return undefined;
  }

  if (activeWorkspaceSession?.patientUserId !== normalized) {
    return startWorkspaceSession(normalized);
  }

  return activeWorkspaceSession.workspaceSessionId;
}

export function endWorkspaceSession(patientUserId?: string): void {
  if (!activeWorkspaceSession) {
    return;
  }

  if (patientUserId === undefined) {
    activeWorkspaceSession = null;
    return;
  }

  const normalized = normalizeUserId(patientUserId);
  if (normalized === '' || activeWorkspaceSession.patientUserId === normalized) {
    activeWorkspaceSession = null;
  }
}
